import packageJson from '../../package.json';

export const environment = {
  production: true,
  version: packageJson.version,
  api_endpoint: 'https://api.sairoadlines.in',
  loggingI: false,
  loggingW: true,
  loggingE: true,
  loggingS: false,
};
